<template>
  <v-autocomplete
    v-model="chosenUser"
    v-bind="$attrs"
    :items="formattedUsers"
    append-icon="mdi-magnify"
    :loading="isLoading"
    :disabled="isLoading"
    small-chips
    clearable
  />
</template>

<script>
import { gql } from "apollo-boost";
export default {
  name: "UserPicker",
  props: {
    initial: {
      type: String,
      default: function() {
        return null;
      },
    },
  },
  data: () => ({
    chosenUser: null,
    totalRecords: 0,
    isLoading: false,
    returnedUsers: [],
    formattedUsers: [],
  }),
  apollo: {
    users: {
      query: gql`
        query Users($limit: Int!, $skip: Int!, $query: JSON!) {
          users(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              firstName
              lastName
            }
            count
          }
        }
      `,
      variables() {
        return {
          limit: 9999,
          skip: 0,
          query: {},
        };
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
      result({ data }, key) {
        this.returnedUsers = data.users.records;
        this.formattedUsers = _.map(this.returnedUsers, (user) => {
          return { text: `${user.firstName} ${user.lastName}`, value: user.id };
        });
      },
    },
  },
  watch: {
    initial(newValue, oldValue) {
      this.chosenUser = this.initial;
    },
    chosenUser(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit(
          "update:chosen-user",
          this.chosenUser ? this.chosenUser : null
        );
      }
    },
  },
  async mounted() {},
  methods: {
    async getFileAsDataURL(documentLink) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (event) => {
          const data = reader.result;
          resolve(data);
        };
        reader.onerror = (e) => {
          console.error(e);
          reject(e);
        };
        reader.readAsDataURL(documentLink);
      });
    },
  },
};
</script>

<style lang="sass"></style>
